/* GRAVIQ – interactions for the custom homepage sections */
(function () {
  'use strict';

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function initReveal(root) {
    (root || document).querySelectorAll('[data-gq-reveal]').forEach(function (el) {
      if (el.__gqReveal) return;
      el.__gqReveal = true;
      if (document.documentElement.classList.contains('shopify-design-mode') || !('IntersectionObserver' in window)) {
        el.classList.add('gq-in');
        return;
      }
      new IntersectionObserver(function (entries, obs) {
        if (entries[0].isIntersecting) {
          el.classList.add('gq-in');
          obs.disconnect();
        }
      }, { threshold: 0.12 }).observe(el);
    });
  }

  /* ---------- hero slider ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-gq-hero]').forEach(function (hero) {
      if (hero.__gqHero) return;
      hero.__gqHero = true;
      var slides = [].slice.call(hero.querySelectorAll('.gq-sl'));
      var tabs = [].slice.call(hero.querySelectorAll('.gq-tab'));
      if (slides.length < 2) return;
      var DUR = (parseFloat(hero.getAttribute('data-duration')) || 4) * 1000;
      var idx = 0, timer = null, remaining = DUR, t0 = 0, paused = false;

      function bar(i) { return tabs[i] && tabs[i].querySelector('i'); }

      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('gq-on', k === idx); });
        tabs.forEach(function (t, k) {
          t.classList.toggle('gq-on', k === idx);
          var b = bar(k); if (b) { b.style.transition = 'none'; b.style.width = '0'; }
        });
        remaining = DUR; t0 = Date.now(); paused = false;
        clearTimeout(timer);
        if (reduce) return;
        var b = bar(idx);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (b) { b.style.transition = 'width ' + DUR + 'ms linear'; b.style.width = '100%'; }
          });
        });
        timer = setTimeout(function () { show(idx + 1); }, DUR);
      }
      function pause() {
        if (paused || reduce) return;
        paused = true; clearTimeout(timer);
        remaining = Math.max(0, remaining - (Date.now() - t0));
        var b = bar(idx); if (b) { var w = getComputedStyle(b).width; b.style.transition = 'none'; b.style.width = w; }
      }
      function resume() {
        if (!paused) return;
        paused = false; t0 = Date.now();
        var b = bar(idx);
        requestAnimationFrame(function () { if (b) { b.style.transition = 'width ' + remaining + 'ms linear'; b.style.width = '100%'; } });
        timer = setTimeout(function () { show(idx + 1); }, remaining);
      }

      var nx = hero.querySelector('[data-gq-next]'), pv = hero.querySelector('[data-gq-prev]');
      if (nx) nx.addEventListener('click', function () { show(idx + 1); });
      if (pv) pv.addEventListener('click', function () { show(idx - 1); });
      tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      hero.addEventListener('mouseenter', pause);
      hero.addEventListener('mouseleave', resume);
      hero.addEventListener('focusin', pause);
      hero.addEventListener('focusout', resume);
      var sx = null;
      hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var d = e.changedTouches[0].clientX - sx;
        if (Math.abs(d) > 40) show(idx + (d < 0 ? 1 : -1));
        sx = null;
      });
      show(0);
    });
  }

  /* ---------- product cards: colour slider + quick add ---------- */
  function initCards(root) {
    (root || document).querySelectorAll('.gq-pc').forEach(function (pc) {
      if (pc.__gqCard) return;
      pc.__gqCard = true;
      var trk = pc.querySelector('.gq-trk');
      var dots = [].slice.call(pc.querySelectorAll('.gq-dots button'));
      var label = pc.querySelector('.gq-cl b');
      var i = 0;
      var data = [];
      var js = pc.querySelector('script[data-gq-variants]');
      try { data = JSON.parse(js ? js.textContent : '[]'); } catch (e) { data = []; }

      function go(k) {
        i = (k + dots.length) % dots.length;
        if (trk) trk.style.transform = 'translateX(-' + i * 100 + '%)';
        dots.forEach(function (d, j) { d.classList.toggle('gq-on', j === i); });
        if (label) {
          label.style.opacity = 0;
          setTimeout(function () { label.textContent = dots[i].getAttribute('aria-label'); label.style.opacity = 1; }, 160);
        }
        markAvailability();
      }
      function markAvailability() {
        var color = dots.length ? dots[i].getAttribute('aria-label') : null;
        pc.querySelectorAll('.gq-qa b').forEach(function (b) {
          var size = b.getAttribute('data-size');
          var v = data.filter(function (x) { return (!color || x.c === color) && x.s === size; })[0];
          b.classList.toggle('gq-off', !v || !v.a);
        });
      }
      dots.forEach(function (d, k) {
        d.addEventListener('click', function (e) { e.preventDefault(); go(k); });
        d.addEventListener('mouseenter', function () { if (matchMedia('(hover: hover)').matches) go(k); });
      });
      var qaTrigger = pc.querySelector('.gq-qa-trigger');
      if (qaTrigger) {
        qaTrigger.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var open = pc.classList.toggle('gq-qa-open');
          qaTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      var ph = pc.querySelector('.gq-ph'), x0 = null;
      if (ph && dots.length > 1) {
        ph.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        ph.addEventListener('touchend', function (e) {
          if (x0 == null) return;
          var d = e.changedTouches[0].clientX - x0;
          if (Math.abs(d) > 35) go(i + (d < 0 ? 1 : -1));
          x0 = null;
        });
      }
      pc.querySelectorAll('.gq-qa b').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var color = dots.length ? dots[i].getAttribute('aria-label') : null;
          var size = b.getAttribute('data-size');
          var v = data.filter(function (x) { return (!color || x.c === color) && x.s === size && x.a; })[0];
          if (!v) return;
          b.classList.add('gq-busy');
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
          }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
            .then(function () { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
            .catch(function () { b.classList.remove('gq-busy'); window.location.href = pc.querySelector('.gq-phl').href; });
        });
      });
      markAvailability();
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    (root || document).querySelectorAll('.gq-faq').forEach(function (f) {
      if (f.__gqFaq) return;
      f.__gqFaq = true;
      f.querySelectorAll('.gq-it2 > button').forEach(function (b) {
        b.addEventListener('click', function () {
          var it = b.parentElement, open = it.classList.contains('gq-open');
          f.querySelectorAll('.gq-it2.gq-open').forEach(function (x) {
            x.classList.remove('gq-open'); x.firstElementChild.setAttribute('aria-expanded', 'false');
          });
          if (!open) { it.classList.add('gq-open'); b.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  }

  /* ---------- category filter (cards + chips filter the product grid) ---------- */
  function initFilters(root) {
    var js = document.getElementById('gq-cats-json');
    if (!js) return;
    var cats = [];
    try { cats = JSON.parse(js.textContent); } catch (e) { return; }
    document.querySelectorAll('.gq-prods').forEach(function (sec) {
      if (sec.__gqFilter) return;
      var chipsBox = sec.querySelector('[data-gq-chips]');
      if (!chipsBox) return;
      sec.__gqFilter = true;
      var cards = [].slice.call(sec.querySelectorAll('.gq-pc'));
      function matches(card, cat) {
        var hay = card.getAttribute(cat.match === 'd' ? 'data-gq-d' : 'data-gq-t') || '';
        return cat.kw.some(function (k) { return hay.indexOf(k) > -1; });
      }
      function apply(slug) {
        var cat = cats.filter(function (c) { return c.slug === slug; })[0];
        chipsBox.querySelectorAll('button').forEach(function (b) {
          b.classList.toggle('gq-on', (b.getAttribute('data-slug') || '') === (cat ? slug : ''));
        });
        cards.forEach(function (c) {
          var show = !cat || matches(c, cat);
          c.classList.toggle('gq-hide', !show);
          if (show && cat) { c.classList.remove('gq-pop'); void c.offsetWidth; c.classList.add('gq-pop'); }
        });
      }
      var all = document.createElement('button');
      all.type = 'button'; all.className = 'gq-chip gq-on'; all.setAttribute('data-slug', '');
      all.textContent = chipsBox.getAttribute('data-all-label') || 'Tout';
      all.addEventListener('click', function () { apply(''); });
      chipsBox.appendChild(all);
      cats.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'gq-chip'; b.setAttribute('data-slug', c.slug); b.textContent = c.title;
        b.addEventListener('click', function () { apply(c.slug); });
        chipsBox.appendChild(b);
      });
      sec.__gqApply = apply;
      var m = /^#cat-(.+)$/.exec(location.hash || '');
      if (m) apply(decodeURIComponent(m[1]));
    });
  }

  if (!window.__gqCatClicks) {
    window.__gqCatClicks = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-gq-cat]') : null;
      if (!a) return;
      var sec = document.querySelector('.gq-prods');
      if (!sec || !sec.__gqApply) return;
      e.preventDefault();
      sec.__gqApply(a.getAttribute('data-gq-cat'));
      sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- product page: colour swatches + size buttons ---------- */
  var HEX = {
    'noir':'#111111','black':'#111111','blanc':'#F1EEE8','white':'#F1EEE8',
    'gris':'#B5B5B5','gris chiné':'#B5B5B5','argent':'#B5B5B5','gray':'#B5B5B5','grey':'#B5B5B5',
    'beige':'#DCCFB6','sable':'#DCCFB6','sand':'#DCCFB6','crème':'#DCCFB6','cream':'#DCCFB6',
    'vert':'#7E9478','green':'#7E9478','kaki':'#7E9478','olive':'#7E9478',
    'bleu':'#3F5B78','blue':'#3F5B78','ardoise':'#3F5B78','marine':'#3F5B78','midnight navy':'#3F5B78',
    'rouge':'#A93A3A','red':'#A93A3A','or':'#C9A96A','gold':'#C9A96A'
  };
  var OVERRIDES = {};
  (function () {
    var raw = document.body ? document.body.getAttribute('data-gq-colors') : '';
    (raw || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf('=');
      if (i > 0) OVERRIDES[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
    });
  })();
  var pickerCache = {};
  function productJson(url) {
    if (!pickerCache[url]) {
      pickerCache[url] = fetch(url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return pickerCache[url];
  }
  function sized(src) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=180'; }

  function decoratePicker(vp) {
    var fieldsets = [].slice.call(vp.querySelectorAll('fieldset.variant-option'));
    fieldsets.forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var name = legend ? (legend.firstChild ? legend.firstChild.textContent : legend.textContent).trim() : '';
      var isColor = /couleur|color|colour/i.test(name), isSize = /taille|size/i.test(name);
      fs.classList.toggle('gq-vo-color', isColor);
      fs.classList.toggle('gq-vo-size', isSize);
      if (!legend) return;
      var val = legend.querySelector('.gq-vo-val');
      if (!val) { val = document.createElement('span'); val.className = 'gq-vo-val'; legend.appendChild(val); }
      var checked = fs.querySelector('input:checked');
      var txt = checked ? checked.value : '';
      if (val.textContent !== txt) val.textContent = txt;
    });
    var colorFs = vp.querySelector('fieldset.gq-vo-color');
    if (!colorFs) return;
    var idx = parseInt(colorFs.getAttribute('data-fieldset-index'), 10) || 0;
    var url = vp.getAttribute('data-product-url');
    var labels = [].slice.call(colorFs.querySelectorAll('label.variant-option__button-label'));
    labels.forEach(function (lb) {
      var input = lb.querySelector('input');
      if (!input) return;
      var key = input.value.toLowerCase().trim();
      var hex = OVERRIDES[key] || HEX[key] || '#9A9A9A';
      if (lb.style.getPropertyValue('--gq-sw') !== hex) lb.style.setProperty('--gq-sw', hex);
    });
    if (!url || !document.body.classList.contains('gq-swatch-photo')) return;
    productJson(url).then(function (prod) {
      if (!prod) return;
      var byValue = {};
      prod.variants.forEach(function (v) {
        var key = (v.options[idx] || '').toLowerCase();
        var img = v.featured_image && v.featured_image.src;
        if (key && img && !byValue[key]) byValue[key] = img;
      });
      labels.forEach(function (lb) {
        var input = lb.querySelector('input');
        var src = input && byValue[input.value.toLowerCase()];
        if (src && lb.style.getPropertyValue('--gq-sw-img') === '') lb.style.setProperty('--gq-sw-img', 'url("' + sized(src) + '")');
      });
    });
  }
  function initPickers() {
    document.querySelectorAll('variant-picker').forEach(function (vp) {
      decoratePicker(vp);
      if (vp.__gqObs) return;
      var t;
      vp.__gqObs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { decoratePicker(vp); }, 30); });
      vp.__gqObs.observe(vp, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-current-checked', 'checked', 'style', 'class'] });
    });
  }

  /* ---------- fading photo slideshow (About page) ---------- */
  function initFade(root) {
    (root || document).querySelectorAll('[data-gq-fade]').forEach(function (box) {
      if (box.__gqFade) return;
      box.__gqFade = true;
      var slides = [].slice.call(box.querySelectorAll('.gq-ab__slide'));
      var dots = [].slice.call(box.querySelectorAll('.gq-ab__dots button'));
      if (slides.length < 2) return;
      var DUR = (parseFloat(box.getAttribute('data-interval')) || 4) * 1000;
      var idx = 0, timer = null, remaining = DUR, t0 = 0, paused = false;
      function bar(i) { return dots[i] && dots[i].querySelector('i'); }
      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('gq-on', k === idx); });
        dots.forEach(function (d, k) {
          d.classList.toggle('gq-done', k < idx);
          var b = bar(k); if (b) { b.style.transition = 'none'; b.style.width = k < idx ? '100%' : '0'; }
        });
        remaining = DUR; t0 = Date.now(); paused = false;
        clearTimeout(timer);
        if (reduce) return;
        var b = bar(idx);
        requestAnimationFrame(function () { requestAnimationFrame(function () { if (b) { b.style.transition = 'width ' + DUR + 'ms linear'; b.style.width = '100%'; } }); });
        timer = setTimeout(function () { show(idx + 1); }, DUR);
      }
      function pause() {
        if (paused || reduce) return;
        paused = true; clearTimeout(timer);
        remaining = Math.max(0, remaining - (Date.now() - t0));
        var b = bar(idx); if (b) { var w = getComputedStyle(b).width; b.style.transition = 'none'; b.style.width = w; }
      }
      function resume() {
        if (!paused) return;
        paused = false; t0 = Date.now();
        var b = bar(idx);
        requestAnimationFrame(function () { if (b) { b.style.transition = 'width ' + remaining + 'ms linear'; b.style.width = '100%'; } });
        timer = setTimeout(function () { show(idx + 1); }, remaining);
      }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
      box.addEventListener('mouseenter', pause);
      box.addEventListener('mouseleave', resume);
      var sx = null;
      box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var d = e.changedTouches[0].clientX - sx;
        if (Math.abs(d) > 40) show(idx + (d < 0 ? 1 : -1));
        sx = null;
      });
      show(0);
    });
  }

  function initAll(root) { initReveal(root); initHero(root); initCards(root); initFaq(root); initFilters(root); initPickers(); initFade(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
